/* Sourced Society | shared scroll rail behaviour (ss-rail): arrows step by visible cards, disable at ends */
if (!customElements.get('ss-rail')) {
  customElements.define('ss-rail', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      const step = () => {
        const card = this.track.querySelector('.ss-card');
        if (!card) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const per = Math.max(1, Math.floor((this.track.clientWidth + gap) / (card.offsetWidth + gap)) - 1);
        return per * (card.offsetWidth + gap);
      };
      this.prev && this.prev.addEventListener('click', () => this.track.scrollBy({ left: -step() }));
      this.next && this.next.addEventListener('click', () => this.track.scrollBy({ left: step() }));
      const sync = () => {
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= max;
      };
      this.track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }
  });
}
